import { ITranslate } from 'locale';
import { ISaveSearch, ISaveSearchFromState } from 'store/sagas/apiService/types';

export function getMultiLocationTitle(savedSearch: ISaveSearch | ISaveSearchFromState, t: ITranslate) {
  if (!savedSearch) return null;
  const { title, locationDocIds } = savedSearch;
  return locationDocIds.length > 1
    ? t('savedSearch.card.title.multipleLocation', { title, count: locationDocIds.length - 1 })
    : title;
}
